import * as Yup from 'yup';

export const generalSchema = Yup.object().shape(
  {
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().email().required('Email is required'),
    phone: Yup.string().required('Phone is required'),
    attendance: Yup.string().optional(),
    interests: Yup.string().optional(),
    comments: Yup.string().optional(),
    subscribe: Yup.boolean().optional(),
    terms: Yup.boolean().oneOf([true], 'You must accept the terms and conditions'),
  },
  [['phone', 'phone']],
);

export const influencerSchema = Yup.object().shape(
  {
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().email().required('Email is required'),
    phone: Yup.string().required('Phone is required'),
    company_name: Yup.string().optional(),
    website_url: Yup.string().optional(),
    followers_number: Yup.number().optional(),
    attendance: Yup.string().required('Attendance plan is required'),
    content_type: Yup.string().optional(),
    comments: Yup.string().optional(),
    subscribe: Yup.boolean().optional(),
    terms: Yup.boolean().oneOf([true], 'You must accept the terms and conditions'),
  },
  [['phone', 'phone']],
);
